var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Slider',{staticClass:"kalender",staticStyle:{"min-height":"100vh"},attrs:{"slider":_vm.slider,"content":_vm.page,"overview":"true","calendar":"all","filter":"true"}}),_vm._v(" "),_c('Leistungsliste',{attrs:{"leistungen":_vm.all,"small":true}},[_vm._v("\n        Unsere Kurse\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c09661c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/endpoints/Kurse.vue
// module id = null
// module chunks = 